export enum MediaType {
  AUDIO = 'audio',
  DOCUMENT = 'document',
  IMAGE = 'image',
  STREAM = 'stream',
  VIDEO = 'video',
  TECHNICAL_DATA = 'technical_data',
}
